<div [class]="skinName">
  <div class="input-container">
    <form #langForm="ngForm" (ngSubmit)="changeLocale()" class="locale-form" name="signinForm" method="post" novalidate>
      <li class="dropdown locale-dropdown">
        <a class="dropdown-toggle" data-toggle="dropdown" [(ngModel)]="selectedLang" name="language" ngDefaultControl>{{selectedLocale}}
          <img loading="lazy" class="locale-caret" src="branding/theme/assets/static_assets/ic-down.svg">
        </a>
        <ul class="dropdown-menu locale-dropdown-menu scrollable-menu" role="menu">
          <div class="border-bot locale-profile">
            @for (value of locales; track value; let index = $index) {
              <li>
                <a role="menuitem" (click)="setLocale(index,value)" tabindex="-1">
                  {{value.translatedLanguage}}
                </a>
              </li>
            }
          </div>
        </ul>
      </li>
      <button type="submit" [disabled]="langForm.invalid" class="uk-button submit-btn">{{ configService.localeKeys?.cng_pass_btn_save_cng_def}}</button>
    </form>
  </div>

</div>